/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import * as Yup from 'yup';

import {
  UI_OPERATION_STATUS_REQUEST,
} from '@uncinc/react-drupal-core';

import {
  FormikWrapper,
  FormCheckbox as Checkbox,
  FormEmail as EmailField,
  FormTextField as TextField,
} from '@uncinc/uncinc-react-kitchen-sink';

import { Button } from '../../../components';
import useClasses from '../../../hooks/useClasses';
import useRoutes from '../../../hooks/useRoutes';
import useOperationStatus from '../../../hooks/useOperationStatus';

// Temporary. See file for more information.
import { userRegisterWithHti } from '../../../store/actions/Login';
import useDispatch from '../../../hooks/useTypedDispatch';

const OnboardingFormHti: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { privacy } = useRoutes();
  const { buildClass } = useClasses('PageOnboarding__form');

  const registerOperationStatus = useOperationStatus('user', 'register');

  const handleSubmit = ({ name, mail }) => {
    dispatch(userRegisterWithHti(name, mail));
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(t('pages.onboarding_credentials_default.fields.fullName.validation.required')),
    mail: Yup.string()
      .email(t('pages.onboarding_credentials_default.fields.email.validation.email'))
      .required(t('pages.onboarding_credentials_default.fields.email.validation.required')),
    privacy: Yup.boolean()
      .isTrue(t('pages.onboarding_credentials_default.fields.privacy.validation.required'))
      .required(t('pages.onboarding_credentials_default.fields.privacy.validation.required')),
  });

  return (
    <FormikWrapper
      initialValues={{
        name: '',
        mail: '',
        privacy: false,
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        handleSubmit(values);
        setSubmitting(false);
      }}
      validateOnChange={false}
      validateOnBlur={false}
    >
      <TextField
        fieldName="name"
        title={t('pages.onboarding_credentials_default.fields.fullName.label')}
        placeholder={t('pages.onboarding_credentials_default.fields.fullName.placeholder')}
      />
      <EmailField
        fieldName="mail"
        title={t('pages.onboarding_credentials_default.fields.email.label')}
        placeholder={t('pages.onboarding_credentials_default.fields.email.placeholder')}
      />
      <Checkbox
        fieldName="privacy"
        title={(
          <Trans i18nKey="pages.onboarding_credentials_default.fields.privacy.label">
            {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
            <a href={privacy} target="_blank" rel="noreferrer" className="textual-link" />
          </Trans>
        )}
      />
      <div className={buildClass('buttons')}>
        <Button
          className={buildClass('submit')}
          htmlType="submit"
          buttonState={registerOperationStatus === UI_OPERATION_STATUS_REQUEST ? 'disabled' : undefined}
        >
          {t('pages.onboarding_credentials_default.submit')}
        </Button>
      </div>
    </FormikWrapper>
  );
};

export default OnboardingFormHti;
